"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SESSION_ID = exports.IS_SANDBOX = exports.EMAIL = exports.DEEPLINK_ID = exports.BOOKING_SESSION_ID = exports.ACCOUNT_ID = void 0;
/**
 * @deprecated Use its SessionStorage value from @kiwicom/cookies instead
 */
const EMAIL = exports.EMAIL = "email";
/**
 * @deprecated Use its SessionStorage value from @kiwicom/cookies instead
 */
const ACCOUNT_ID = exports.ACCOUNT_ID = "accountId";
const SESSION_ID = exports.SESSION_ID = "sessionId";
const DEEPLINK_ID = exports.DEEPLINK_ID = "deeplinkId";
const BOOKING_SESSION_ID = exports.BOOKING_SESSION_ID = "bookingSessionId";
const IS_SANDBOX = exports.IS_SANDBOX = "isSandbox";

// TODO specific once everyone uses this